export const сryptopayButton = (id, amount, interval, onApproveFunction) => window.cryptopay.Button({
  createPayment: function(actions) {
    return actions.payment.create({
      currency: 'USD',
      amount: amount,
      description : 'HeyLink.me subscription',
      'metadata': {
        customer_id: id,
        interval: interval,
      },
    });
  },
  onApprove: function (data, actions) {
    onApproveFunction(data);
}}).render("#pay-button");
